module.exports = __webpack_public_path__ + "static/szenario1_3-26940a49f3c7232ae7916e4d2a1b48f6.png";